import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, Col } from 'reactstrap';
import ReactTableBase from '../../../shared/components/table/ReactTableBase';

const SubscriberResizableTable = ({ reactTableData, data, customClass,type }) => {
  const [rowData, setData] = useState([]);
  const [isSortable, setIsSortable] = useState(false);
  const [isResizable, setIsResizable] = useState(true);
  const [withPagination, setWithPaginationTable] = useState(true);
  const [withSearchEngine, setWithSearchEngine] = useState(true);
  console.log(reactTableData)
  console.log(data)
  useEffect(() => {
    setData(data || []);
}, [data]);

  const updateEditableData = (rowIndex, columnId, value) => {
    setData(old => old.map((item, index) => {
      if (index === rowIndex) {
        return {
          ...old[rowIndex],
          [columnId]: value,
        };
      }
      return item;
    }));
  };

  const handleClickIsSortable = () => {
    setIsSortable(!isSortable);
  };

  const handleClickWithPagination = () => {
    setWithPaginationTable(!withPagination);
  };

  const handleClickIsResizable = () => {
    setIsResizable(!isResizable);
  };

  const handleClickWithSearchEngine = () => {
    setWithSearchEngine(!withSearchEngine);
  };

  const tableConfig = {
    isEditable: false,
    isResizable: true,
    isSortable: true,
    withPagination,
    withSearchEngine,
    manualPageSize: [250, 500, 1000, 1500, 2000],
    placeholder: 'Search by Title...',
  };

  return (
    // <Col md={12} lg={12}>
      <Card>
        <CardBody className={`${customClass} pl-0 pr-0`}>
          <ReactTableBase
            key={withSearchEngine ? 'searchable' : 'common'}
            columns={type === 'status' ? reactTableData.tableImportOrderStatusHeader : reactTableData.tableHeaderData}
            data={rowData}
            tableConfig={tableConfig}
            
          />
        </CardBody>
      </Card>
    // </Col>
  );
};

SubscriberResizableTable.propTypes = {
  reactTableData: PropTypes.shape({
    tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    })),
    tableImportOrderStatusHeader: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    })),
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  customClass: PropTypes.string,
  type: PropTypes.string
};

SubscriberResizableTable.defaultProps = {
  customClass: '',
  type: ''
}

export default SubscriberResizableTable;
